// src/app/services/ihk-education-voucher.service.ts

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IhkEducationVoucher } from '../models/ihkeducationvoucher.model';
import { map, Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { Activity } from '../models/activity.model';

@Injectable({
  providedIn: 'root',
})
export class IhkEducationVoucherService {
  private apiUrl = `${environment.apiUrl}/Voucher`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<IhkEducationVoucher[]> {
    return this.http.get<IhkEducationVoucher[]>(`${this.apiUrl}`);
  }

  getById(id: number): Observable<IhkEducationVoucher> {
    return this.http.get<IhkEducationVoucher>(`${this.apiUrl}/${id}`);
  }

  createVoucher(data: IhkEducationVoucher): Observable<any> {
    return this.http.post<IhkEducationVoucher>(
      `${this.apiUrl}/CreateVoucher`,
      data,
    );
  }

  updateActivityType(
    activityId: number,
    newType: string,
  ): Observable<Activity> {
    return this.http.patch<Activity>(
      `${this.apiUrl}/activity/${activityId}/type`,
      `"${newType}"`,
      { headers: { 'Content-Type': 'application/json' } },
    );
  }

  deleteVoucher(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  uploadFile(id: number, file: File): Observable<string> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<string>(`${this.apiUrl}/upload/${id}`, formData);
  }

  getAllDocuments(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/all-documents`);
  }
  getVoucherStylesFromDb(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/ListSettings`).pipe(
      map((values) =>
        values.map((v) => ({
          value: v.value, // z.B. 'IHKAnmeldung'
          label: v.label, // Mapping: DB 'label' -> Frontend 'label'
          icon: v.icon, // z.B. 'pi pi-file'
          color: v.color, // z.B. '#B22222'
        })),
      ),
    );
  }
}
